import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFactoryService } from '../../auth/auth-factory.service';
import { HttpOptions } from '../general/interfaces/http-options';
import { RestGenericUtilService } from '../rest-generic-util.service';
import { RestGeneric } from '../rest.generic';
import { StudentAttendanceActivity } from './interfaces/student-attendance-activity';
import { StudentAttendanceQR } from './interfaces/student-attendance-qr';

/**
 * Includes all API calls related to the QR code and the updating of the attendance
 */
@Injectable({
  providedIn: 'root'
})
export class StudentAttendanceQRService extends RestGeneric<string, StudentAttendanceActivity, any> {
  constructor(
    protected http: HttpClient,
    protected authFactoryService: AuthFactoryService,
    protected restGenericUtilService: RestGenericUtilService
  ) {
    super(http, authFactoryService, 'qr-attendance', restGenericUtilService);
  }

  postCatchallAttendance(requestBody: { token: string }): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.baseApiUrl}/${this.schoolUUid}/flex-period/student/catchall-attendance`,
      requestBody
    );
  }

  postActivityAttendance(requestBody: { token: string }): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.baseApiUrl}/${this.schoolUUid}/flex-period/activity/scheduled-activity/scheduled-activity-scheduling/attendance`,
      requestBody
    );
  }

  /**
   * Sends QR code data (token) based on that API returns full activity info
   */
  getActitivyByQRToken(endpointParams: { token: string }): Observable<StudentAttendanceActivity> {
    const params = this.restGenericUtilService.toParams({ ...endpointParams });

    return this.http.get<StudentAttendanceActivity>(`${this.baseApiUrl}/${this.endpointName}/qr-activity`, { params });
  }

  /**
   * Gets general activity info
   */
  getActivityQR(scheduling: string): Observable<StudentAttendanceQR> {
    const params = this.restGenericUtilService.toParams({ scheduling });

    return this.http.get<StudentAttendanceQR>(`${this.baseApiUrl}/${this.endpointName}`, { params });
  }

  /**
   * Gets general catchall activity info
   */
  getCatchallActivityQR(flexPeriod: string, date: string): Observable<StudentAttendanceQR> {
    const params = this.restGenericUtilService.toParams({ flexPeriod, date });

    return this.http.get<StudentAttendanceQR>(`${this.baseApiUrl}/${this.endpointName}`, { params });
  }

  /**
   * Exports general activity info and the QR code to pdf document
   */
  exportToPdf(options: HttpOptions): Observable<ArrayBuffer> {
    const params = this.restGenericUtilService.toParams(options.params);

    return this.http.get(`${this.baseApiUrl}/${this.endpointName}/export`, {
      params,
      headers: options.headers,
      responseType: 'arraybuffer'
    });
  }
}
